module.exports = __webpack_public_path__ + "media/attorney/footer-26df1b23.jpg";